/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Fragment, useEffect, useRef, useState } from "react";
import "../../../assets/css/custom_style.css";
import { Navigation, Pagination, Zoom } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { translations } from "../../../assets/meemLabels";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
//@ts-ignore
import { isEmptyObject } from "jquery";
import useBussinessPage from "../../hooks/useBussiness";
import { useParams, useSearchParams } from "react-router-dom";
import { useScrollLock } from "../../hooks/useScrollLock";
import BasketPage from "../BasketPage";
import "react-slideshow-image/dist/styles.css";
import {
  social_name,
  ObjectKey,
  ObjectKeyLng,
  buy2Get3halfOfferProducts,
  buy2Get3FullOfferProducts,
} from "./utils";
import useItemDetail from "../../hooks/useItemDetails";
import Accordion from "../Accordion/Accordion";
import Loader from "../Loader";
import MiniBasket from "../components/MiniBasket";
import CartIconSvg from "../components/CartIconSvg";
import IconInfo from "../components/IconInfo";
import BussinessInfoPage from "../components/BussinessInfoPage";
import Seperator from "../components/Seperator";
import { adjustRenderReactViwer, numberWithCommas } from "../utilis";
import Footer from "../components/Footer";
import WhatsappIcon from "../components/WhatsappIcon";
import TermsCondition from "../TermsCondition";
import { genShortLink } from "./utils";
import WhatsappButton from "../components/WhatsappButton";
import DisplayDiscountMessage from "../shared/DisplayDiscountMessage";
const ProductDetail: React.FC = () => {
  var elementBlockColor = document.getElementById("block_color");
  const [searchParams] = useSearchParams();
  const { bussinessName, socailName } = useParams();
  const shopCartStrg = localStorage.getItem("shopCart");
  const parsedShopCart = shopCartStrg && JSON.parse(shopCartStrg);
  const [selectedImageUrl, setSelectedImageUrl] = useState<string>("");
  const [defaultLang, setDefaultLang] = useState<ObjectKeyLng>("en");
  const [value, setValue] = useState("1");

  const [multipleOption, setMultipleOption] = useState<any>([]);
  const [multipleOptionNew, setMultipleOptionNew] = useState<any>([]);
  const [addNewValue, setAddNewValue] = useState(true);
  const [customPrize, setCustomPrize] = useState(0);
  const colorErrorRef = useRef<HTMLDivElement>(null);
  const sizeErrorRef = useRef<HTMLDivElement>(null);
  const multipleOptionErrRef = useRef(null);
  const { getItemDetailByid, itemDetail } = useItemDetail();
  const { getUserToken, useData, userToken, loading } = useBussinessPage();
  const [selectedItemPrice, setSelectedItemPrice] = useState<number>(0);
  const [singleItemPrice, setSingleItemPrice] = useState<number>(0);

  const [selectedItemName, setSelectedName] = useState<string>("");
  const [selectedItemId, setSelectedItemId] = useState<number | null>(null);
  const [selectedColor, setSelectedColor] = useState<string>("");
  const [selectedSize, setSelectedSize] = useState<string>("");
  const [showBussinessPage, setShowBussinessPage] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);
  const [showSizeError, setShowSizeError] = useState<boolean>(false);
  const [cartFinal, setCartFinal] = useState({});
  const [showBasketPop, setShowBasketPop] = useState<boolean>(false);
  const [showMiniBask, setShowMiniBask] = useState(false);
  const { lockScroll, unlockScroll } = useScrollLock();
  const [showButton, setShowButton] = useState<boolean>(true);
  const [whatsappButtonLoading, setWhatsappBtnLoading] =
    useState<boolean>(false);
  const [arrayForMultipleOptionError, setArrForMulOptErr] = useState<number[]>(
    []
  );
  // url parameters
  const getUniqeId = searchParams.get("id");
  const getPageType = searchParams.get("p");
  const ttclid = searchParams.get("ttclid");
  const utm_medium = searchParams.get("utm_medium") || "N/A";
  const utm_campaign = searchParams.get("utm_campaign") || "N/A";
  // url parameters
  //@ts-ignore
  const userWIfiIp = window.userWifiIp;
  const handleClose = () => {
    setAddNewValue(true);
    unlockScroll();
    setShowMiniBask(false);
  };
  const handleShow = () => {
    setShowMiniBask(true);
    lockScroll();
  };
  const handleShowBussinessPage = () => {
    lockScroll();
    setShowBussinessPage(true);
  };
  const handleHideBussinessPage = () => {
    // closeBussinessPage();
    // setTimeout(() => {
    //   setShowBussinessPage(false);
    // }, 4000);
    setShowBussinessPage(false);
    unlockScroll();
  };

  // functions for changing for input price

  const onChangeInputPrice = (
    itemPrice: any,
    itemId: number,
    itemName: string
  ) => {
    // setSelectedItemPrice(itemPrice);
    setSingleItemPrice(itemPrice);
    setSelectedItemId(itemId);
    setSelectedName(itemName);
    setCustomPrize(selectedItemPrice + itemPrice * parseInt(value));
    setShowError(false);
    // arrayForMultipleOptionError
  };

  // functions for color selection
  const chooseColorHandler = (item: string, img_url?: string | undefined) => {
    if (img_url) {
      setSelectedImageUrl(img_url);
    }
    setSelectedColor(item);
    setShowError(false);
    elementBlockColor?.classList.remove("shake_animation");
  };
  const chooseSizeHandler = (item: string) => {
    setSelectedSize(item);
    setShowSizeError(false);
  };
  const checkMultipleOptionArr = (checkId: any) => {
    var totalNumber = 0;
    var tempArr = [];
    var displayButton = false;
    multipleOption.forEach((element: any) => {
      if (element.id === checkId) {
        displayButton = true;
        tempArr.push(element);
        // return displayButton;
      }
    });
    totalNumber = tempArr.length;
    return { displayButton, totalNumber };
  };

  // Get the product details based on the productId
  const getNumberOfItemBasesOnId = (extraOptionId: string | number) => {
    var numberOfItems = 0;
    multipleOptionNew.forEach((element: any) => {
      // console.log("called");
      if (element.main_id == extraOptionId) {
        numberOfItems += element.quantity;
        return;
      }
    });

    return numberOfItems;
  };

  const addExtraOption = (
    extraOptionWithItems: any,
    action: string,
    extraOption: any
  ) => {
    var oldOptionsArray = multipleOptionNew;
    var isNew = true;
    const addToCart = () => {
      setCustomPrize((prev) => prev + extraOption.actual_price);
      //notes : here we will ensure that only on item inserted in case of item_type =  option or null
      if (extraOption.item_type !== "check-box") {
        setArrForMulOptErr((prev) => [
          ...prev.filter((value: any) => value !== extraOptionWithItems.id),
        ]);
        setMultipleOptionNew((prev: any) => [
          ...prev.filter((value: any) => value.item_type === "check-box"), // Keep only checkboxes
          { ...extraOption, quantity: 1, main_id: extraOptionWithItems.id }, // Add the new item
        ]);

        return;
      }
      //notes : here we will ensure that only on item inserted in case of item_type =  check-boxes
      if (extraOption.item_type === "check-box") {
        setArrForMulOptErr((prev) => [
          ...prev.filter((value: any) => value !== extraOptionWithItems.id),
        ]);
        setMultipleOption((prev: any) => [...prev, extraOption]);
        if (isNew) {
          setMultipleOptionNew((prev: any) => [
            ...prev,
            { ...extraOption, quantity: 1, main_id: extraOptionWithItems.id },
          ]);
        } else {
          setMultipleOptionNew(oldOptionsArray);
        }
      }
    };
    if (action === "add") {
      if (extraOptionWithItems.is_mandatory === "Yes") {
        if (extraOption.item_type !== "check-box") {
          addToCart();
          return;
        }
        if (getNumberOfItemBasesOnId(extraOptionWithItems.id) === 0) {
          addToCart();
          return;
        }
        if (
          getNumberOfItemBasesOnId(extraOptionWithItems.id) <
          extraOptionWithItems.mandatory_amount
        ) {
          oldOptionsArray.forEach((element: any, index: number) => {
            if (element.id === extraOption.id) {
              oldOptionsArray[index].quantity = element.quantity + 1;
              isNew = false;
              return;
            }
          });
          addToCart();
        }
      }
      if (extraOptionWithItems.is_mandatory === "No") {
        oldOptionsArray.forEach((element: any, index: number) => {
          if (element.id === extraOption.id) {
            oldOptionsArray[index].quantity = element.quantity + 1;
            isNew = false;
            return;
          }
        });
        addToCart();
      }
    } else {
      setCustomPrize(
        (prev) =>
          prev -
          extraOption.actual_price *
            checkMultipleOptionArr(extraOption.id).totalNumber
      );
      setMultipleOption((prev: any) =>
        prev.filter((value: any) => value.id !== extraOption.id)
      );
      setMultipleOptionNew((prev: any) =>
        prev.filter((value: any) => value.id !== extraOption.id)
      );
    }

    // console.log(maxAmount);
  };

  const getExtraAmountQty = () => {
    let extraAmount = 0;
    let isMandatory = "No";

    for (const [key, option] of Object.entries(itemDetail!.extra_options)) {
      const { is_mandatory, id, mandatory_amount } = option;

      if (
        is_mandatory === "Yes" &&
        getNumberOfItemBasesOnId(id) < mandatory_amount
      ) {
        isMandatory = "Yes";
        extraAmount = mandatory_amount;

        if (!arrayForMultipleOptionError.includes(id)) {
          setArrForMulOptErr((prev) => [...prev, id]);
        }
        break; // Exit early if a condition is met
      }
    }

    return { extraAmount, isMandatory };
  };

  const checkColorSize = () => {
    var newObj = {};
    if (
      isEmptyObject(itemDetail?.colors) &&
      isEmptyObject(itemDetail?.color_image) &&
      !Array.isArray(itemDetail?.sizes)
    ) {
      return null;
    } else {
      newObj = {
        color: selectedColor,
        size: selectedSize,
        img_url: selectedImageUrl !== "" ? selectedImageUrl : undefined,
      };
      return newObj;
    }
  };
  const openBasketHandler = () => {
    if (parsedShopCart && parsedShopCart.length > 0) {
      lockScroll();
      setShowMiniBask(false);
      setShowBasketPop(true);
    }
  };
  const openMiniBasketHandler = () => {
    if (parsedShopCart && parsedShopCart.length > 0) {
      lockScroll();
      setShowMiniBask(true);
      // setShowBasketPop(true);
    }
  };

  const onPressCloseHandler = (addNew: boolean) => {
    unlockScroll();
    if (addNew === true) {
      setAddNewValue(true);
    } else {
      setAddNewValue(false);
    }

    setShowBasketPop(false);
  };
  const opneWhatsapp = async () => {
    var phoneNumber = useData?.sp_whatsapp_number;
    // %0A
    // var messgaeWhatsapp = "Hey , i am interested in this product ";
    //  ${messgaeWhatsapp} *Product:* ${window.location.href}
    // https://api.whatsapp.com/
    // https://wa.me/1XXXXXXXXXX
    const message = ``;
    var source = { fb: "Facebook", tiktok: "TikTok", google: "Google" };
    const message_tiktok = `${
      window.location.origin + window.location.pathname
    }?id=${getUniqeId}&p=w&click_id=${ttclid}&source=${
      source.tiktok
    }&utm_source=${
      source.tiktok
    }&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_term=NA&utm_content=URL&user_ip=${userWIfiIp}&utmreq=yes`;

    if (null !== ttclid && userToken) {
      setWhatsappBtnLoading(true);
      genShortLink(message_tiktok, userToken).then((shortUrl) => {
        if (shortUrl) {
          const urlEncodedMessage = encodeURIComponent(
            `${translations.whatsapp_redirect_msg[defaultLang]} ${shortUrl}`
          );
          const whatsappURL = `https://wa.me/${phoneNumber}?text=${urlEncodedMessage}`;
          document.location.href = whatsappURL;
        }
        setWhatsappBtnLoading(false);
      });
      return;
    }
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${message}`;
    document.location.href = whatsappURL;
    // document.location.href = `https://wa.me/${phoneNumber}/text=urlencodedtext`;
  };

  const onPressButton = () => {
    let shopCart: any = [];
    if (shopCartStrg !== null) {
      shopCart = JSON.parse(shopCartStrg);
    }
    if (itemDetail?.is_customized === "Yes") {
      if (getExtraAmountQty().isMandatory === "Yes") {
        return;
      } else {
        addToBasket(shopCart);
        return;
      }
    } else {
      addClothStore(shopCart);
    }
  };

  const addClothStore = (shopCart: any) => {
    if (
      selectedColor === "" &&
      (itemDetail?.colors !== null || itemDetail?.color_image !== null) &&
      useData?.resto_meta?.BUSSINESS_TYPE === "ClothsStore"
    ) {
      setShowError(true);
      setTimeout(() => {
        elementBlockColor?.classList.add("shake_animation");
      }, 0);
      if (colorErrorRef.current) {
        const rect = colorErrorRef?.current?.getBoundingClientRect();
        window.scrollTo({
          top: rect.top + window.scrollY - 500,
          behavior: "smooth",
        });
      }
      setTimeout(() => {
        elementBlockColor?.classList.remove("shake_animation");
      }, 300);
    } else if (
      selectedSize === "" &&
      itemDetail?.sizes &&
      useData?.resto_meta?.BUSSINESS_TYPE === "ClothsStore"
    ) {
      setShowSizeError(true);
      if (sizeErrorRef.current) {
        const rect = sizeErrorRef?.current?.getBoundingClientRect();
        window.scrollTo({
          top: rect.top + window.scrollY - 500,
          behavior: "smooth",
        });
      }
    } else {
      addToBasket(shopCart);
    }
  };
  const checkSingleItemPrice = () => {
    if (singleItemPrice !== 0) {
      return singleItemPrice;
    }
    return parseInt(itemDetail ? itemDetail?.price : "0");
  };

  const addToBasket = (shopCart: any) => {
    var tempArrExtraOption: any = [];
    if (multipleOptionNew.length > 0) {
      multipleOptionNew.forEach((element: any) => {
        tempArrExtraOption.push({
          id: element.id,
          parent_id: element.main_id,
          quantity: element.quantity,
          price: element.price,
        });
      });
    }
    // var shopCartForGTM = [];
    setShowError(false);
    setShowSizeError(false);
    let cart = {
      id: itemDetail?.shared_unique_id,
      price: customPrize,
      quantity: value,
      affiliation: social_name[socailName as ObjectKey],
      //@ts-ignore
      name: itemDetail?.name[defaultLang],
      single_item_name: selectedItemName,
      single_item_price: singleItemPrice,
      multiple_option: multipleOptionNew,
      single_options: selectedItemId,
      extra_options: tempArrExtraOption,
      actual_price: checkSingleItemPrice(),
      //@ts-ignore
      description: itemDetail?.description[defaultLang],
      color_size: checkColorSize(),
    };
    // let cartGTM = {
    //   item_id: itemDetail?.shared_unique_id,
    //   price: customPrize,
    //   affiliation: social_name[socailName as ObjectKey],
    //   quantity: value,
    //   //@ts-ignore
    //   item_name: itemDetail?.name[defaultLang],
    //   color: selectedColor,
    //   size: selectedSize,
    //   single_item_name: selectedItemName,
    //   single_item_price: singleItemPrice,
    //   multiple_option: multipleOption,
    //   single_options: selectedItemId,
    //   actual_price: checkSingleItemPrice(),
    //   //@ts-ignore
    //   description: itemDetail?.description[defaultLang],
    // };

    if (addNewValue) {
      //@ts-ignore
      shopCart.push(cart);
      // shopCartForGTM.push(cartGTM);
      localStorage.setItem("shopCart", JSON.stringify(shopCart));
      setCartFinal(cart);
      setAddNewValue(false);
    }
    if (!addNewValue) {
      if (shopCartStrg !== null) {
        shopCart[shopCart.length - 1] = cart;
        localStorage.setItem("shopCart", JSON.stringify(shopCart));
      }
    }
    handleShow();
    // setShowBasketPop(true);
  };
  useEffect(() => {
    //function for gtm
    localStorage.removeItem("shopCart");
    localStorage.removeItem("shopCartGTM");
    getItemDetailByid(getUniqeId);
    getUserToken(bussinessName!);
    // getData();
  }, []);
  useEffect(() => {
    if (itemDetail !== undefined) {
      setCustomPrize(parseInt(itemDetail?.price));
      adjustRenderReactViwer();
      if (itemDetail.price !== "0") {
        setSelectedItemPrice(parseInt(itemDetail?.price));
      }
    }
  }, [itemDetail]);
  useEffect(() => {
    if (useData !== undefined) {
      document.documentElement.style.setProperty(
        "--background-color-store",
        useData?.default_color
      );
    }
    const favicon = document.getElementById("favicon");
    //@ts-ignore
    favicon.href = useData?.site_logo;
    // if (useData !== undefined) {
    if (useData?.default_lang === "ar") {
      document.body.dir = "rtl";
    } else {
      document.body.dir = "ltr";
    }
    setDefaultLang(useData?.default_lang as ObjectKeyLng);
    // }
  }, [useData]);
  useEffect(() => {
    if (addNewValue === true) {
      //@ts-ignore
      setCustomPrize(parseInt(itemDetail?.price));
      setSelectedColor("");
      setValue("1");
      setMultipleOptionNew([]);
      setMultipleOption([]);
      setSelectedItemId(null);
      setSelectedSize("");
      setCartFinal({});
    }
  }, [addNewValue]);
  useEffect(() => {
    console.log(multipleOptionNew);
  }, [multipleOptionNew]);
  // Detect if the browser is TikTok's in-app browser
  const isTiktokBrowser = /TikTok|musical_ly|BytedanceWebview/i.test(
    navigator.userAgent
  );

  // Replace with your target URL

  useEffect(() => {
    if (isTiktokBrowser) {
      let touchStartX = 0;
      let touchStartY = 0;

      const handleTouchStart = (e: any) => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      };

      const handleTouchMove = (e: any) => {
        const touchMoveX = e.touches[0].clientX;
        const touchMoveY = e.touches[0].clientY;
        const deltaX = Math.abs(touchMoveX - touchStartX);
        const deltaY = Math.abs(touchMoveY - touchStartY);

        // Prevent the default action only if the swipe is primarily horizontal
        if (deltaX > deltaY) {
          e.preventDefault();
          e.stopPropagation();
        }
      };

      // Attach event listeners to the entire document
      document.addEventListener("touchstart", handleTouchStart, {
        passive: false,
      });
      document.addEventListener("touchmove", handleTouchMove, {
        passive: false,
      });

      return () => {
        // Clean up event listeners when the component unmounts
        document.removeEventListener("touchstart", handleTouchStart);
        document.removeEventListener("touchmove", handleTouchMove);
      };
    }
  }, [isTiktokBrowser]);
  return (
    <>
      <div className="main-wrapper">
        {!loading ? (
          <div className="landscape" lang={useData?.default_lang}>
            <div
              id="pop_prod_detail"
              className="main_page  pop_up_maps_main  productDetails "
            >
              <>
                <div></div>
                <div className="">
                  <div className="content ">
                    {!showMiniBask && !showBasketPop && !showBussinessPage && (
                      <div className="header">
                        {getPageType === null && (
                          <div
                            className="cart-button-button "
                            onClick={openMiniBasketHandler}
                          >
                            <CartIconSvg />
                            {parsedShopCart && parsedShopCart.length !== 0 && (
                              <span className="cart-counter">
                                {parsedShopCart.length}
                              </span>
                            )}
                          </div>
                        )}
                        {getPageType === "w" && <div></div>}

                        <div onClick={handleShowBussinessPage}>
                          <IconInfo />
                        </div>
                      </div>
                    )}
                    {/* <div>{direction}</div> */}

                    {itemDetail?.gallery?.length !== 0 &&
                      useData !== undefined && (
                        <Swiper
                          className="swiper-main swiper-container"
                          // zoom={true}
                          // pagination={{ clickable: true }}
                          style={{
                            marginTop: 40,
                          }}
                          resistanceRatio={0}
                          dir={useData?.default_lang === "ar" ? "rtl" : "ltr"}
                          // install Swiper modules
                          modules={[
                            Navigation,
                            Pagination,
                            // Scrollbar,
                            // A11y,
                            Zoom,
                          ]}
                          spaceBetween={7}
                          slidesPerView={1.5}
                          // loop={true}
                        >
                          {itemDetail?.gallery?.map((fadeImage, index) => {
                            return (
                              <SwiperSlide className="swiper prdSwiper">
                                <div
                                  className="swiper-slide"
                                  style={{
                                    backgroundImage: `url(${fadeImage})`,
                                  }}
                                ></div>
                              </SwiperSlide>
                            );
                          })}
                        </Swiper>
                      )}
                    {/* )} */}
                    {itemDetail?.gallery?.length === 0 && (
                      <div
                        className="swiper-slide"
                        style={{
                          marginTop: 40,
                          backgroundImage: `url(${itemDetail?.main_image})`,
                        }}
                      ></div>
                    )}

                    {/* <Viewer
                      className="force-ltr"
                      visible={visibleZoom}
                      onClose={() => {
                        setVisibleZoom(false);
                      }}
                      images={itemDetail?.gallery.map((image, i) => ({
                        src: `${image}`,
                        alt: `image ${i + 1} `,
                      }))}
                      
                    /> */}

                    <div className="body_warp">
                      <div className="">
                        <div className="container_name pop_prod_sticky">
                          {itemDetail &&
                            (buy2Get3halfOfferProducts.includes(
                              itemDetail.id
                            ) ||
                              buy2Get3FullOfferProducts.includes(
                                itemDetail.id
                              )) && (
                              <DisplayDiscountMessage
                                message={
                                  buy2Get3FullOfferProducts.includes(
                                    itemDetail.id
                                  )
                                    ? translations.offer_message_full[
                                        defaultLang
                                      ]
                                    : translations.offer_message[defaultLang]
                                }
                                showIcon={true}
                              />
                            )}
                          <h3 className="font-family">
                            {/* @ts-ignore */}
                            {itemDetail?.name[defaultLang]}
                          </h3>

                          {itemDetail && itemDetail?.actual_price !== "0" && (
                            <div className="item-main-price">
                              <span>
                                {" "}
                                {numberWithCommas(itemDetail?.actual_price)}
                              </span>
                              {"  "}
                              <span>
                                {
                                  useData?.resto_meta?.BUSSINESS_CCY_LANG[
                                    defaultLang
                                  ]
                                }
                              </span>
                            </div>
                          )}
                          {itemDetail !== undefined && (
                            <p
                              style={{ marginBottom: 13 }}
                              className="light_grey_text read_more "
                              dangerouslySetInnerHTML={{
                                //@ts-ignore
                                __html: itemDetail?.description[defaultLang],
                              }}
                            ></p>
                          )}
                        </div>
                        <Seperator />
                        {getPageType === null && (
                          <>
                            {useData?.resto_meta?.BUSSINESS_TYPE ===
                              "ClothsStore" && (
                              <div>
                                {(itemDetail?.colors !== null ||
                                  itemDetail?.color_image !== null) && (
                                  <Fragment>
                                    <div
                                      id="block_color"
                                      style={{ display: "block" }}
                                      className={` color-section popup_radio_label ${
                                        showError && "border-error"
                                      }`}
                                    >
                                      <div
                                        className="container"
                                        style={{
                                          paddingLeft: "23px",
                                          paddingRight: "23px",
                                        }}
                                      >
                                        {(itemDetail?.colors !== null ||
                                          itemDetail?.color_image !== null) && (
                                          <div>
                                            <div className="disp_flex">
                                              <h3 className="text-muted">
                                                {[227].includes(useData?.id)
                                                  ? translations.choose_frag[
                                                      defaultLang
                                                    ]
                                                  : translations.choose_color[
                                                      defaultLang
                                                    ]}
                                              </h3>
                                              {showError && (
                                                <span className="show_please_select">
                                                  {
                                                    translations
                                                      .pleaseMakeSelection[
                                                      defaultLang
                                                    ]
                                                  }
                                                </span>
                                              )}
                                            </div>
                                            <div
                                              className={`${
                                                itemDetail?.color_image !== null
                                                  ? "colors-img"
                                                  : "colors"
                                              }`}
                                              ref={colorErrorRef}
                                            >
                                              {itemDetail?.colors !== null &&
                                                itemDetail?.colors?.map(
                                                  (item, index) => {
                                                    return (
                                                      <span
                                                        className={`color choose-color ${
                                                          item ===
                                                            selectedColor &&
                                                          "active"
                                                        }`}
                                                        style={{
                                                          backgroundColor: item,
                                                        }}
                                                        // style={{ backgroundColor: "item" }}
                                                        // data-value={item}
                                                        onClick={() =>
                                                          chooseColorHandler(
                                                            item
                                                          )
                                                        }
                                                      ></span>
                                                    );
                                                  }
                                                )}

                                              {itemDetail?.color_image !==
                                                null &&
                                                itemDetail?.color_image?.map(
                                                  (item, index) => {
                                                    return (
                                                      <span
                                                        className={`color choose-color color_img_heigth ${
                                                          item.color ===
                                                            selectedColor &&
                                                          "active"
                                                        }`}
                                                        style={{
                                                          borderRadius: 5,
                                                          marginLeft: 10,
                                                          backgroundImage: `url(${item?.img_url})`,
                                                        }}
                                                        onClick={() =>
                                                          chooseColorHandler(
                                                            item.color,
                                                            item?.img_url
                                                          )
                                                        }
                                                      />
                                                    );
                                                  }
                                                )}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <Seperator />
                                  </Fragment>
                                )}
                                {itemDetail?.sizes && (
                                  <div
                                    ref={sizeErrorRef}
                                    style={{ flexDirection: "column" }}
                                    id="sizeColor"
                                    className={`size-section popup_radio_label ${
                                      showSizeError && "border-error"
                                    }`}
                                  >
                                    <div className="disp_flex">
                                      <h3 className="text-muted">
                                        {translations.choose_size[defaultLang]}
                                      </h3>
                                      {showSizeError && (
                                        <span className="show_please_select">
                                          {
                                            translations.pleaseMakeSelection[
                                              defaultLang
                                            ]
                                          }
                                        </span>
                                      )}
                                    </div>
                                    <div className="sizes">
                                      {itemDetail?.sizes?.map((item, index) => {
                                        return (
                                          <span
                                            className={`size choose-size ${
                                              item === selectedSize && "active"
                                            }`}
                                            onClick={() =>
                                              chooseSizeHandler(item)
                                            }
                                          >
                                            {item}
                                          </span>
                                        );
                                      })}
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}

                            {itemDetail !== undefined &&
                              itemDetail.extra_options && (
                                <div
                                  className="container "
                                  style={{
                                    paddingLeft: "0px",
                                    paddingRight: "23px",
                                  }}
                                >
                                  <form action="">
                                    <br />
                                    {Object.entries(
                                      itemDetail.extra_options
                                    ).map((item, index) => {
                                      return (
                                        <div>
                                          <div
                                            ref={multipleOptionErrRef}
                                            className={`popup_radio_label ${
                                              arrayForMultipleOptionError.includes(
                                                item[1].id
                                              )
                                                ? "border-error show_product_error_box"
                                                : ""
                                            }`}
                                          >
                                            <div className="col_90_percent">
                                              <div className={`Customize`}>
                                                <>
                                                  <b>
                                                    {/* @ts-ignore */}
                                                    {
                                                      item[1].name_lang[
                                                        defaultLang
                                                      ]
                                                    }
                                                  </b>
                                                  {/* )} */}
                                                  {showError &&
                                                    item[1].is_mandatory ===
                                                      "Yes" && (
                                                      <div
                                                        style={{
                                                          color: "red",
                                                          marginTop: 10,
                                                        }}
                                                      >
                                                        {
                                                          translations
                                                            .choose_atleast[
                                                            defaultLang
                                                          ]
                                                        }
                                                        <b
                                                          style={{
                                                            marginLeft: 5,
                                                            marginRight: 5,
                                                          }}
                                                        >
                                                          {
                                                            getExtraAmountQty()
                                                              .extraAmount
                                                          }{" "}
                                                        </b>
                                                      </div>
                                                    )}
                                                </>
                                              </div>
                                            </div>
                                            {item[1].is_mandatory === "Yes" && (
                                              <div className="col_30_percent ">
                                                <div
                                                  className={`radio_right_req ${
                                                    arrayForMultipleOptionError.includes(
                                                      item[1].id
                                                    ) && "colour-red"
                                                  }`}
                                                >
                                                  <span>
                                                    ({item[1].mandatory_amount})
                                                    {"  "}
                                                  </span>
                                                  {
                                                    translations.required_txt[
                                                      defaultLang
                                                    ]
                                                  }
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                          {item[1]?.items?.map(
                                            (itemA, index) => (
                                              <div>
                                                <div className="popup_radio_label">
                                                  <div className="col_70_percent">
                                                    <div
                                                      onClick={() => {
                                                        // console.log(item[1]);
                                                        itemA.item_type ===
                                                          "check-box" &&
                                                          addExtraOption(
                                                            item[1],
                                                            "add",
                                                            itemA
                                                          );
                                                      }}
                                                      className="title_opt_product"
                                                      dangerouslySetInnerHTML={{
                                                        __html:
                                                          itemA.name_lang[
                                                            defaultLang
                                                          ],
                                                      }}
                                                    />
                                                  </div>
                                                  <div className="col_30_percent ">
                                                    {multipleOption?.length >
                                                      0 &&
                                                      itemA.item_type ===
                                                        "check-box" &&
                                                      checkMultipleOptionArr(
                                                        itemA.id
                                                      ).displayButton && (
                                                        <label
                                                          style={{
                                                            color: "red",
                                                            fontSize: 12,
                                                            marginRight: 5,
                                                          }}
                                                        >
                                                          x
                                                          {
                                                            checkMultipleOptionArr(
                                                              itemA.id
                                                            ).totalNumber
                                                          }
                                                        </label>
                                                      )}
                                                    {itemA.price !== 0 ? (
                                                      <span>
                                                        <label
                                                          // for={itemA.id}
                                                          className="light_grey_text font_s"
                                                        >
                                                          {numberWithCommas(
                                                            itemA.price
                                                          )}
                                                        </label>

                                                        <label className="light_grey_text font_s">
                                                          {
                                                            useData?.resto_meta
                                                              .BUSSINESS_CCY_LANG[
                                                              defaultLang
                                                            ]
                                                          }
                                                        </label>
                                                      </span>
                                                    ) : (
                                                      <span>
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                      </span>
                                                    )}
                                                    <>
                                                      {itemA.item_type ===
                                                        "option" && (
                                                        <input
                                                          // style={{ marginTop: "5px" }}
                                                          // inputMode=""
                                                          type="radio"
                                                          checked={
                                                            selectedItemId ===
                                                            itemA.id
                                                          }
                                                          id={itemA.id.toString()}
                                                          // name="parent_opt_1"
                                                          value={numberWithCommas(
                                                            itemA.price
                                                          )}
                                                          className="radio_right"
                                                          onChange={() => {
                                                            addExtraOption(
                                                              item[1],
                                                              "add",
                                                              itemA
                                                            );
                                                            onChangeInputPrice(
                                                              itemA.price,
                                                              itemA.id,
                                                              itemA.name_lang[
                                                                defaultLang
                                                              ]
                                                            );
                                                          }}
                                                        />
                                                      )}
                                                    </>

                                                    <>
                                                      {itemA.item_type ===
                                                        null && (
                                                        <input
                                                          // style={{ marginTop: "3px" }}
                                                          // inputMode=""
                                                          type="radio"
                                                          checked={
                                                            selectedItemId ===
                                                            itemA.id
                                                          }
                                                          id={itemA.id.toString()}
                                                          // name="parent_opt_1"
                                                          value={numberWithCommas(
                                                            itemA.price
                                                          )}
                                                          className="radio_right"
                                                          onChange={() => {
                                                            addExtraOption(
                                                              item[1],
                                                              "add",
                                                              itemA
                                                            );
                                                            onChangeInputPrice(
                                                              itemA.price,
                                                              itemA.id,
                                                              itemA.name_lang[
                                                                defaultLang
                                                              ]
                                                            );
                                                          }}
                                                        />
                                                      )}
                                                    </>

                                                    <>
                                                      {multipleOption?.length >
                                                        0 &&
                                                        itemA.item_type ===
                                                          "check-box" &&
                                                        checkMultipleOptionArr(
                                                          itemA.id
                                                        ).displayButton && (
                                                          <>
                                                            <svg
                                                              onClick={() =>
                                                                addExtraOption(
                                                                  item[1],
                                                                  "delete",
                                                                  itemA
                                                                )
                                                              }
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              viewBox="0 0 1000 1000"
                                                              //  aria-disabled={loading}
                                                              fill="currentColor"
                                                              data-spec="icon-plus"
                                                              className="w-5 h-5"
                                                              style={{
                                                                width: 12,
                                                                height: 12,
                                                              }}
                                                            >
                                                              {/* <glyph glyph-name="trash" unicode="&#xee09;" horiz-adv-x="1000" /> */}
                                                              <path
                                                                fill="orange"
                                                                d="M844.9 233.4c-115.10000000000002 0.5-230.19999999999993 0.29999999999998295-345.29999999999995 0.29999999999998295v-0.09999999999999432h-345.3c-11.900000000000006 0-23.100000000000023-1.5999999999999943-20.100000000000023 17.400000000000006 17 107.69999999999999 33.20000000000002 215.5 49.80000000000001 323.20000000000005 16.30000000000001 106.39999999999998 35.19999999999999 212.39999999999998 48.099999999999994 319.0999999999999 6.700000000000017 55.80000000000007 53.900000000000006 107.70000000000005 118.00000000000003 106.70000000000005 99.19999999999999-1.6000000000000227 198.29999999999995-0.10000000000002274 297.5-0.5 66.69999999999993-0.2999999999999545 109.5-38.5 119.29999999999995-104.60000000000002 19.800000000000068-132.79999999999995 39.700000000000045-265.6 59.80000000000007-398.4 12.199999999999932-80.69999999999999 24.199999999999932-161.39999999999998 37.5-241.9 2.8999999999999773-18.19999999999999-2.800000000000068-21.19999999999999-19.300000000000068-21.19999999999999z m-317.19999999999993 149.4c-0.7000000000000455 160.90000000000003-0.10000000000002274 321.8-0.20000000000004547 482.7h-55.10000000000002c-0.0999999999999659-80.10000000000002-0.0999999999999659-160.29999999999995-0.0999999999999659-240.39999999999998h0.19999999999998863c0-82.39999999999998 0.5-164.8-0.39999999999997726-247.20000000000005 0-2.5 0.0999999999999659-4.599999999999966 0.2999999999999545-6.599999999999966h54.60000000000002c0.5 3.3000000000000114 0.7000000000000455 7.199999999999989 0.7000000000000455 11.5z m-288.90000000000003-11.5h55c1.3000000000000114 3.8000000000000114 2.099999999999966 8.300000000000011 2.8000000000000114 13.599999999999966 14.099999999999966 113.80000000000001 30.399999999999977 227.30000000000007 46.19999999999999 340.9 6.5 46.60000000000002 13.800000000000011 93 19.5 139.70000000000005h-55.69999999999999c-15-107.79999999999995-30.100000000000023-215.5-45-323.29999999999995-7.800000000000011-56.30000000000007-15.000000000000028-112.70000000000005-22.600000000000023-169.10000000000002l-0.19999999999998863-1.8000000000000114z m493.8 200.2c-13.600000000000023 98-28.399999999999977 195.79999999999995-40.200000000000045 294h-55.60000000000002c22.700000000000045-161.60000000000002 44.30000000000007-323.29999999999995 66.40000000000009-484.9 0.39999999999997726-2.8000000000000114 0.39999999999997726-6.100000000000023 0.6999999999999318-9.300000000000011h56.89999999999998c-0.599999999999909 4-1.7999999999999545 8.300000000000011-2.2999999999999545 11.800000000000011-8.399999999999977 62.89999999999998-17.100000000000023 125.69999999999999-25.899999999999977 188.39999999999998z m208.89999999999998-413.7c-10.799999999999955-25.700000000000017-28.5-46.80000000000001-48.200000000000045-66.10000000000001-21.5-21-45.799999999999955-33-77.39999999999998-32.2-60.799999999999955 1.5-121.60000000000002 0-182.39999999999998 0.5-13.200000000000045 0.10000000000000142-20.399999999999977-1.7999999999999972-24.5-16.6-8.5-30.599999999999998-27.700000000000045-43.199999999999996-59.299999999999955-43.3-34-0.10000000000000142-68.00000000000006-0.20000000000000143-102.00000000000006 0.09999999999999859-29.80000000000001 0.2-49.39999999999998 14.100000000000001-57.599999999999966 42.8-3.900000000000034 13.600000000000001-10 17.6-24.100000000000023 17.4-60.80000000000001-1-121.6-1-182.3-0.3999999999999986-53.5 0.5-116.79999999999998 53.3-128.7 105.5-3.6000000000000014 16.099999999999994 2 25.400000000000006 17.700000000000003 28.30000000000001 7.799999999999997 1.3999999999999773 15.799999999999997 1.5 23.700000000000003 1.5 133.9 0.09999999999999432 267.79999999999995 0.09999999999999432 401.6 0h182.29999999999995l184.5 0.09999999999999432c18.100000000000023 0 36.30000000000007 0.5 54.200000000000045-0.9000000000000057 24.600000000000023-1.9000000000000057 31.899999999999977-14.400000000000006 22.5-36.69999999999999z"
                                                              />
                                                            </svg>
                                                          </>
                                                        )}
                                                    </>
                                                  </div>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      );
                                    })}
                                  </form>
                                </div>
                              )}
                          </>
                        )}
                        {/* {
                          <div className="container">
                            <div className="cart_content_row">
                              <div className="title_acc_cell">
                                {"height (cm)"}
                              </div>
                              <div className="">
                                <input
                                  onChange={(e) => {
                                    // setUserName(e.target.value);
                                    // setShowNameErr(false);
                                  }}
                                  // value={"111"}
                                  type="text"
                                  className={`cart_mobile_input_type ${
                                    showError && "border-error"
                                  }`}
                                />
                              </div>
                            </div>
                            <div className="cart_content_row">
                              <div className="title_acc_cell">
                                {"weight (kg)"}
                              </div>
                              <div className="">
                                <input
                                  onChange={(e) => {
                                    // setUserName(e.target.value);
                                    // setShowNameErr(false);
                                  }}
                                  // value={"111"}
                                  type="text"
                                  className={`cart_mobile_input_type ${
                                    showError && "border-error"
                                  }`}
                                />
                              </div>
                            </div>
                          </div>
                        } */}
                        {itemDetail !== undefined &&
                          useData?.resto_meta?.ENABLED_PRODUCT_FAQS === "Yes" &&
                          itemDetail?.product_faqs?.length !== 0 && (
                            <>
                              {itemDetail &&
                                (itemDetail.extra_options ||
                                  itemDetail?.colors !== null ||
                                  itemDetail?.color_image !== null) && (
                                  <Seperator />
                                )}
                              <Accordion
                                defautlLang={defaultLang}
                                dataQuestion={itemDetail?.product_faqs}
                              />
                            </>
                          )}
                        <br />
                        <br />

                        <TermsCondition
                          onClickInfo={handleShowBussinessPage}
                          defaultLang={defaultLang}
                          bussinessDetails={useData}
                        />
                        <br />
                        <br />
                        {getPageType === null && (
                          <div className="bottomProductTotal">
                            {/* {useData !== undefined && ( */}
                            <button
                              className="add_cart_btn"
                              onClick={onPressButton}
                            >
                              <div className="prod_counted_price">
                                {!Number.isNaN(customPrize)
                                  ? numberWithCommas(customPrize)
                                  : ""}{" "}
                                {
                                  useData?.resto_meta?.BUSSINESS_CCY_LANG[
                                    defaultLang
                                  ]
                                }
                                {"  "}
                              </div>
                              <div className="prod_add_to_cart">
                                {translations.add_item[defaultLang]}
                              </div>
                            </button>
                          </div>
                        )}
                        {getPageType === "w" && (
                          <div
                            className="bottomProductTotal"
                            style={{ flexDirection: "column" }}
                          >
                            {/* {useData !== undefined && ( */}

                            <button
                              className="button-landing-whatsapp "
                              onClick={opneWhatsapp}
                            >
                              {!whatsappButtonLoading ? (
                                <>
                                  <div className="prod_counted_price">
                                    <WhatsappIcon />
                                  </div>

                                  <span
                                    style={{ marginLeft: 10, marginRight: 10 }}
                                  >
                                    {
                                      translations.contact_us_whatsapp[
                                        defaultLang
                                      ]
                                    }
                                  </span>
                                </>
                              ) : (
                                <Loader
                                  height={15}
                                  width={15}
                                  colorProp="white"
                                />
                              )}
                            </button>
                            <span
                              style={{
                                marginBottom: 5,
                                textAlign: "center",
                                marginTop: 10,
                              }}
                            >
                              {translations.you_will_be_redirected[defaultLang]}
                            </span>
                          </div>
                        )}
                        {useData?.resto_meta?.ENABLE_WHATSAPP_FLOATING_BUTTON ==
                          "Yes" &&
                          showButton &&
                          getPageType !== "w" && (
                            <WhatsappButton
                              //   @ts-ignore
                              productName={itemDetail?.name[defaultLang]}
                              whatsappNumber={useData?.sp_whatsapp_number}
                              onPressClose={() => setShowButton(false)}
                            />
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            </div>

            {showMiniBask && (
              <MiniBasket
                defaultLang={defaultLang}
                onPressAddMore={handleClose}
                restoData={useData}
                onPressBasket={openBasketHandler}
              />
            )}
            {showBussinessPage && (
              <BussinessInfoPage
                useData={useData}
                onPressClose={handleHideBussinessPage}
                defaultLang={defaultLang}
              />
            )}

            {showBasketPop === true && (
              <BasketPage
                restoData={useData}
                restoToken={userToken!}
                socailType={social_name[socailName as ObjectKey]}
                restoName={bussinessName!}
                selectColorProp={selectedColor}
                selectSizeProp={selectedSize}
                itemDetail={itemDetail}
                onPressClose={(addNew) => onPressCloseHandler(addNew)}
                cartValues={cartFinal}
              />
            )}
          </div>
        ) : (
          <div className={" loader-wrapper"}>
            <Loader width={50} height={50} colorProp={"black"} />
            {/* <div style={{ marginTop: 10 }}></div> */}
          </div>
        )}

        <Footer
          siteLogo={useData?.site_logo}
          bussinessName={useData?.name[defaultLang]}
        />
      </div>
    </>
  );
};

export default ProductDetail;
